import gql from 'graphql-tag';

export const deleteCostOffsetCodeMutation = gql(/* GraphQL */ `
  mutation deleteCostOffsetCode(
    $deleteCostOffsetCodeRequest: DeleteCostOffsetCodeRequest!
  ) {
    deleteCostOffsetCode(
      deleteCostOffsetCodeRequest: $deleteCostOffsetCodeRequest
    )
  }
`);
